import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import App from './App'
import { analyticsPageView } from './analyticsPageView'
import { GlobalErrorBoundary, installGlobalErrorLogging } from './GlobalErrorBoundary'

installGlobalErrorLogging()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <BrowserRouter>
        {process.env.REACT_APP_RELEASE_ENVIRONMENT === 'staging' && <div role="status" style={{background:'#752c00',color:'#fff',padding:'12px',textAlign:'center',fontWeight:700}}>STAGING — TEST DATA ONLY · No real payments or publicly shareable wins</div>}
        <App />
        <Analytics beforeSend={analyticsPageView} />
      </BrowserRouter>
    </GlobalErrorBoundary>
  </React.StrictMode>
)

if (process.env.REACT_APP_RELEASE_ENVIRONMENT !== 'staging' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => registration.update().catch(() => {}))
      .catch(() => {});
  });
}

